import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {SliderSlideClickEvent} from "../models/events/slider-slide.click-event";
import {ACTION_TYPES} from "../consts";

export class SliderSlideClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.sliderSlide;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = SliderSlideClickEvent;
  }
}
